module.exports = __webpack_public_path__ + "static/media/bells.d5f521c1.svg";